import Services from "./Services";
import TitleBarMin from "@/components/elements/TitleBar/TitleBarMin";

const ServicesPage = () => {
  return (
    <>

      {/* <TitleBarMin title="Services"></TitleBarMin> */}

      <div >
        {/* For the gap below nav */}
      </div>
      <div >
      <Services />
      </div>



    </>
  );
};

export default ServicesPage;
